"use strict";
/**
This is probably not going to be used directly by a consumer, but rather is a base class for
other formatters that will instantiate it with options. Because we want to be able to source
formatters that have no dependencies for use in the client with the least overhead, deps
for formatting dates are not "imported" but injected by the consumer.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const utility_1 = require("../common/utility");
const DATE_FORMAT = "yyyy-mm-dd HH:MM:ss.l";
const DATE_WIDTH = 19;
const SOURCE_WIDTH = 20;
class StandardFormatter {
    /**
     * Creates an instance of StandardFormatter.
     *
     * @param {FormatterDependencies} deps Dependencies (should include 'dateformat' if 'date: true' is specified in options, and 'ansiFormatter' if colors: true }
     */
    constructor(deps = {}) {
        Object.assign(this, { options: {} }, deps);
        this.maybeColorize = maybeColorize.bind(this);
    }
    /**
     * Given
     *
     * @param { WithWildcards<WriterOutput> } obj The Log object
     * @returns {string} A string
     */
    format(obj) {
        const { options } = this;
        const level = obj.level.toUpperCase().slice(0, 5);
        let text = (options.date ? `${utility_1.pad(this.dateformat(obj.timestamp, DATE_FORMAT), DATE_WIDTH)} ` : '') +
            this.maybeColorize(utility_1.pad(`[${level.slice(0, 5)}]`, 7), obj.level) + ' ' +
            ((options.source || obj.source) ? utility_1.pad(`[${(obj.source || '').slice(0, SOURCE_WIDTH - 2)}] `) : '') +
            (options.showId && obj.id ? `{${obj.id}} ` : ``) +
            obj.message +
            (obj.userId || '') +
            (obj.stack ? `\n${obj.stack}` : '');
        return text;
    }
}
function maybeColorize(text, color) {
    if (!this.options.colors)
        return text;
    return this.colorize(text, color);
}
exports.default = StandardFormatter;
//# sourceMappingURL=standard.js.map